import {Component, inject, Input} from '@angular/core';
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {IPaymentTier} from "../../interfaces/player/IPaymentTier";
import {GameService} from "../../services/game.service";
import {ErrorHandlingService} from "../../services/error-handling.service";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {GameTypeEnum} from "../../enum/GameTypeEnum";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {MatRadioButton, MatRadioGroup} from "@angular/material/radio";
import {PipesModule} from "../../pipes/pipes.module";
import {FormsModule} from "@angular/forms";
import {MatButton} from "@angular/material/button";
import {IAddPaymentTiersToGame} from "../../interfaces/IAddPaymentTiersToGame";
import {ActiveUserService} from "../../services/active-user.service";
import {SnackbarService} from "../../services/snackbar.service";
import {MatError} from "@angular/material/form-field";
import {MatDialog} from "@angular/material/dialog";
import {NewPaymentTierComponent} from "../dialogs/new-payment-tier/new-payment-tier.component";

@Component({
  selector: 'app-edit-payment-tiers-goldrush',
  standalone: true,
  imports: [
    MatProgressSpinner,
    MatRadioButton,
    MatRadioGroup,
    PipesModule,
    FormsModule,
    MatButton,
    MatError
  ],
  templateUrl: './edit-payment-tiers-goldrush.component.html',
  styleUrl: './edit-payment-tiers-goldrush.component.css'
})
export class EditPaymentTiersGoldrushComponent {
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);
  private gameService: GameService = inject(GameService);
  private snackbarService: SnackbarService = inject(SnackbarService);
  private activeUserService: ActiveUserService = inject(ActiveUserService);
  private matDialog: MatDialog = inject(MatDialog);

  @Input() set gameSetter(gameP: IGameQueryResult | null) {
    if (gameP) {
      this.game = gameP;
      this.getAllPaymentTiersForGame(gameP);
    }
  }

  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  protected readonly UIStateEnum = UIStateEnum;
  protected readonly GameTypeEnum = GameTypeEnum;

  public availablePaymentTiers: IPaymentTier[] = [];
  public gamePaymentTier: IPaymentTier | null = null;
  public newTierForGame: IPaymentTier | null = null;
  public gameId: string = '';
  public game: IGameQueryResult | null = null;
  public showNoPaymentTierMessage: boolean = false;

  private getAllPaymentTiersForGame(gameP: IGameQueryResult): void {
    this.uiState = UIStateEnum.ShowLoading;
    this.gameService.getAllPaymentTiers(gameP.Id)
      .subscribe({
        next: (paymentTiersP) => {
          this.gameId = gameP.Id;
          this.availablePaymentTiers = paymentTiersP;
          this.gamePaymentTier = gameP.PaymentTiers[0] ?? null;
          this.uiState = UIStateEnum.ShowData;
        }, error: (err) => {
          this.uiState = UIStateEnum.ShowData;
          this.errorHandlingService.displayPageLevelErrorMessage(err);
        }
      })
  }

  addNewTier() {
    const dialogRef = this.matDialog.open(NewPaymentTierComponent,
      {
        data: this.gameId
      });

    dialogRef.afterClosed().subscribe({
      next: (successfullyAddedTier) => {
        if (successfullyAddedTier) {
          this.getAllPaymentTiersForGame(this.game!)
        }
      }
    })
  }

  addPaymentTierToGame() {
    if (!this.newTierForGame) {
      this.showNoPaymentTierMessage = true;
      return;
    }
    this.showNoPaymentTierMessage = false;
    this.uiState = UIStateEnum.ShowLoading;

    const addPaymentTierRequest: IAddPaymentTiersToGame = {
      gameId: this.gameId,
      adminId: this.activeUserService.activeUser().Id,
      paymentTierIds: [this.newTierForGame.Id]
    };

    this.gameService.addPaymentTierToGame(addPaymentTierRequest)
      .subscribe({
        next: (updatedGame) => {
          this.uiState = UIStateEnum.ShowData;
          this.snackbarService.openSuccessfulSnackBar('Successfully added payment tier');
          this.gameSetter = updatedGame;
        }, error: () => {
          this.uiState = UIStateEnum.ShowData;
          this.snackbarService.openErrorSnackBar('Failed to add payment tier');
        }
      })
  }
}
